// extracted by mini-css-extract-plugin
export default {"noDataMessage":"grid_noDataMessage__Xh36h"};